import { processSilentRenew } from 'redux-oidc';

processSilentRenew();



//////////////////
// WEBPACK FOOTER
// ./silent_renew/index.js
// module id = 30
// module chunks = 5 6